import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({

  questionImg: {
    width: "100px",
    height: "100px",
    marginRight: "2.5rem",
    cursor: "pointer",
    // position: 'absolute',
    zIndex: "5",
    userDrag: 'none',
    [emulatorScreen(theme)]: {
      width: 100,
      height: 100,
      marginRight: "1.5rem",
    },
    [mobileScreen(theme)]: {
      width: "60px",
      height: "60px",
      marginRight: "1.5rem",
      marginLeft: 5,
      alignSelf: "flex-start",
    }
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
    textTransform: "uppercase",
    [mobileScreen(theme)]: {
      fontSize: "14px",
      marginBottom: "2px"
    }
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
    [emulatorScreen(theme)]: {
      fontSize: "13px",
      lineHeight: "1.1",
    },
    [mobileScreen(theme)]: {
      fontSize: "11px",
      maxWidth: "100%",
    }
  },

  boldText: {
    fontWeight: 700,
    lineHeight: "1.2",
    [emulatorScreen(theme)]: {
      fontSize: 14
    },
    [mobileScreen(theme)]: {
      lineHeight: "1",
      fontSize: 14
    }
  },

  iconTraceBack: {
    width: "100px",
    height: "100px",
    position: "absolute",
    zIndex: "3",
    top: "0",
    borderRadius: "50%",
    border: "3px dashed #003e4c",
    backgroundColor: "#ecf2f1",
    [emulatorScreen(theme)]: {
      width: 110,
      height: 110,
    },
    [mobileScreen(theme)]: {
      width: "57px",
      height: "57px",
    }
  },

  draggableMainContainer: {
    width: "100px",
    height: "100px",
    position: "relative",
    [mobileScreen(theme)]: {
      width: "60px",
      height: "60px",
    }
  },

  draggableContainer: {
    width: "100px",
    height: "100px",
    position: "absolute",
    zIndex: "10",
    [mobileScreen(theme)]: {
      width: "60px",
      height: "60px",
    }
  },

  draggableElement: {
    width: "550px",
    flexWrap: "nowrap",
    [emulatorScreen(theme)]: {
      width: "420px",
    },
    [mobileScreen(theme)]: {
      width: "325px",
    }
  }

});

export default styles;
